import {
  selectAIContext,
  selectEditingCollection,
  selectLinkRecords,
  selectUser,
} from "../../redux/features/appData";
import "./AIAnswer.css";
import { LinkRecord } from "winslow-core";
import { LinkRecordActivity } from "./LinkRecordActivity";
import { useSelector } from "react-redux";
import { handleCopyText } from "../uiHelpers";
import {
  getStoreLinkRecord,
  getLinkRecordIdsFromContext,
  iconPath,
} from "winslow-core";
import { marked } from "marked";

type AIAnswerProps = {
  //aiResponse: AIResponseSave;
  answer: string;
  aiLinkRecords: LinkRecord[];
  question: string;
};

export default function AIAnswer({
  question,
  answer,
  aiLinkRecords,
}: AIAnswerProps) {
  const storeUser = useSelector(selectUser);
  const linkRecords = useSelector(selectLinkRecords);
  const aiContext = useSelector(selectAIContext);
  const currentCollection = useSelector(selectEditingCollection);

  // const [savedAIResponse, setSavedAIResponse] = useState<AIResponseSave>({
  //   ...aiResponse,
  // });

  const linkRecordIds = getLinkRecordIdsFromContext(aiContext, linkRecords);

  return (
    <>
      <div className="ai-response">
        <div className="ai-response-question-content">
          {question.substring(0, 80) + (question.length > 80 ? "..." : "")}
        </div>

        {linkRecordIds && linkRecordIds.length > 0 && (
          <div className="ai-response-context">
            <div className="ai-response-context-label">Sources</div>
            <div className="ai-response-context-sources">
              {linkRecordIds.map((lrId: string) => {
                if (!linkRecords) {
                  return <></>;
                }

                const linkRecord = getStoreLinkRecord(
                  lrId,
                  currentCollection?.linkRecords
                    ? currentCollection?.linkRecords
                    : []
                );

                if (!linkRecord) {
                  return <></>;
                }

                return (
                  <>
                    {linkRecord && (
                      <LinkRecordActivity
                        linkRecord={linkRecord}
                        minimum={true}
                        showDrag={false}
                        clickIsOpen={true}
                      />
                    )}
                  </>
                );
              })}
            </div>
          </div>
        )}

        {!linkRecordIds ||
          (linkRecordIds.length < 1 && aiLinkRecords && (
            <>
              <div className="ai-response-context">
                <div className="ai-response-context-label">Sources</div>
                <div className="ai-response-context-sources">
                  {aiLinkRecords.map((linkRecord: LinkRecord) => {
                    let fullLinkRecord = null;

                    if (linkRecords) {
                      fullLinkRecord = getStoreLinkRecord(
                        linkRecord.id,
                        linkRecords
                      );
                    }

                    return (
                      <>
                        {linkRecord && (
                          <LinkRecordActivity
                            key={"link-record-activity-" + linkRecord.id}
                            linkRecord={
                              fullLinkRecord ? fullLinkRecord : linkRecord
                            }
                            minimum={true}
                            showDrag={false}
                            clickIsOpen={true}
                          />
                        )}
                      </>
                    );
                  })}
                </div>
                {aiLinkRecords.length < 1 && (
                  <div className="ai-response-context-none">
                    <p>No applicable sources.</p>
                  </div>
                )}
              </div>
            </>
          ))}

        <div className="ai-response-answer-outer">
          <div className="ai-response-winslow">Answer</div>

          <div className="ai-response-answer-container">
            <div className="ai-response-buttons">
              <div
                className="ai-response-button"
                onClick={() => {
                  handleCopyText(answer);
                }}>
                <img src={iconPath("copy.svg", storeUser)} alt="" />
              </div>
            </div>

            <div
              className="ai-response-answer"
              dangerouslySetInnerHTML={{
                __html: marked(answer) as string,
              }}></div>
          </div>
        </div>
      </div>
    </>
  );
}
